<template>
  <li class="boxed" role="button"  @keyup.enter="onSelection(item)">
    <a class="box-title" tabindex="8">
      <i v-for="(icon,i) in icons" :key="i" :class="icon" style="color: #37474f; margin-right: .5rem"></i>
      <span :style="titleStyle" v-html="title" />
    </a>
    <small v-html="description" />
  </li>
</template>

<script>
export default {
  name: "Header",
  props: {
    title: String,
    description: String,
    icons: Array,
    pos: Number,
    titleWeight: Number,
    onSelection: Function,
    item: Object
  },
  methods: {
  },
  computed: {
    titleStyle () {
      return `font-weight: ${this.titleWeight || 700}`
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: unset;
  text-decoration: unset;
  display: block;
}
</style>
